/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var _extend = __webpack_require__(12);
	
	var Logger = __webpack_require__(63);
	var Receiver = __webpack_require__(1).comm.Receiver;
	var AlertApi = __webpack_require__(1).api.Alert;
	var Transmitter = __webpack_require__(64);
	var DialogApi = __webpack_require__(65);
	var DialogFactory = __webpack_require__(66);
	var connect = __webpack_require__(70);
	var _getFullUrlByTarget = __webpack_require__(81);
	var MessageHandlerNavigate = __webpack_require__(83);
	var messageHandlers = [__webpack_require__(85), // Removed behind flipper: ui_integration_remove_confirm
	__webpack_require__(86), // only
	__webpack_require__(87), __webpack_require__(88), // Removed behind flipper: ui_integration_remove_get_full_url_by_target
	__webpack_require__(89), // Removed: ui_integration_remove_intercom_track_event
	__webpack_require__(90), __webpack_require__(91), __webpack_require__(83), // Removed behind flipper: ui_integration_remove_navigate
	__webpack_require__(92), __webpack_require__(93), // Removed behind flipper: ui_integration_remove_refresh
	__webpack_require__(94), __webpack_require__(95) // Removed behind flipper: ui_integration_remove_track
	];
	
	window.Emarsys = window.Emarsys || (window.SUITE ? _extend(true, {}, window.SUITE) : {});
	window.Emarsys.config = window.Emarsys.config || (window.SUITE.config ? _extend(true, {}, window.SUITE.config) : {});
	
	var transmitter = new Transmitter({
	  global: window,
	  integrationId: 'EMARSYS',
	  integrationInstanceId: 'EMARSYS'
	});
	var receiver = new Receiver(window);
	
	window.Emarsys.integration = {
	  messageToEmarsys: function messageToEmarsys() {
	    Logger.sendLog('window messageToEmarsys');
	    transmitter.messageToEmarsys.apply(transmitter, arguments);
	  },
	  messageToService: function messageToService() {
	    Logger.sendLog('window messageToService');
	    transmitter.messageToService.apply(transmitter, arguments);
	  },
	  addMessageHandler: function addMessageHandler() {
	    Logger.sendLog('window addMessageHandler');
	    receiver.addMessageHandler.apply(receiver, arguments);
	  },
	  alert: AlertApi.create(transmitter), // Add log later
	  dialog: new DialogApi(transmitter, DialogFactory.create()),
	  getFullUrlByTarget: function getFullUrlByTarget(_ref) {
	    var target = _ref.target,
	        params = _ref.params;
	
	    // Causes problems in a datagrid on automation programs
	    // Logger.sendLog('window getFullUrlByTarget', { target, params });
	    return _getFullUrlByTarget({ // same as get_url but not migrated yet
	      sessionId: window.Emarsys.config.session_id,
	      target: target,
	      params: params
	    });
	  },
	  navigate: function navigate(messageData) {
	    Logger.sendLog('window navigate', { messageData: messageData });
	    var messageHandler = new MessageHandlerNavigate(window, null);
	    return messageHandler.navigate({ data: messageData });
	  },
	  unload: {
	    initialized: false
	  }
	};
	
	messageHandlers.forEach(function (MessageHandlerClass) {
	  var messageHandler = new MessageHandlerClass(window, transmitter);
	  receiver.addMessageHandler(messageHandler.MESSAGE_EVENT, messageHandler.handleMessage.bind(messageHandler));
	});
	
	connect(window);
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Transmitter = __webpack_require__(2);
	var Receiver = __webpack_require__(3);
	
	var AlertApi = __webpack_require__(4);
	var DialogApi = __webpack_require__(6);
	var MiscApi = __webpack_require__(8);
	var UnloadApi = __webpack_require__(9);
	var UpdateHashApi = __webpack_require__(10);
	var IntercomApi = __webpack_require__(11);
	
	var createInstance = function createInstance(options) {
	  var transmitter = new Transmitter(options);
	  var receiver = new Receiver(options.global);
	
	  return Object.assign({
	    messageToEmarsys: transmitter.messageToEmarsys.bind(transmitter),
	    messageToService: transmitter.messageToService.bind(transmitter),
	    addMessageHandler: receiver.addMessageHandler.bind(receiver)
	  }, MiscApi.create(transmitter, receiver), {
	    alert: AlertApi.create(transmitter),
	    dialog: DialogApi.create(transmitter, receiver),
	    updateHash: UpdateHashApi.create(transmitter),
	    unload: UnloadApi.create(transmitter),
	    intercom: IntercomApi.create(transmitter)
	  });
	};
	
	module.exports = {
	  integrationClient: createInstance({
	    global: window,
	    integrationId: 'DEFAULT',
	    integrationInstanceId: 'DEFAULT'
	  }),
	  init: createInstance,
	  comm: {
	    Transmitter: Transmitter,
	    Receiver: Receiver
	  },
	  api: {
	    Alert: AlertApi,
	    Dialog: DialogApi,
	    Misc: MiscApi,
	    Unload: UnloadApi,
	    UpdateHash: UpdateHashApi,
	    Intercom: IntercomApi
	  }
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Transmitter = function () {
	  function Transmitter(options) {
	    _classCallCheck(this, Transmitter);
	
	    this.global = options.global;
	    this.integrationId = options.integrationId;
	    this.integrationInstanceId = options.integrationInstanceId;
	  }
	
	  _createClass(Transmitter, [{
	    key: 'messageToEmarsys',
	    value: function messageToEmarsys(eventName, data) {
	      this.global.parent.postMessage(JSON.stringify(this.setMessageSource(this.compileMessage(eventName, data))), '*');
	    }
	  }, {
	    key: 'messageToService',
	    value: function messageToService(eventName, data, targetInstanceId) {
	      this.messageToEmarsys('proxy', {
	        event: eventName,
	        envelope: data,
	        integrationInstanceId: targetInstanceId
	      });
	    }
	  }, {
	    key: 'compileMessage',
	    value: function compileMessage(eventName, data) {
	      return {
	        event: eventName,
	        data: data
	      };
	    }
	  }, {
	    key: 'setMessageSource',
	    value: function setMessageSource(message) {
	      return Object.assign({}, message, {
	        source: {
	          integration_id: this.integrationId,
	          integration_instance_id: this.integrationInstanceId
	        }
	      });
	    }
	  }]);
	
	  return Transmitter;
	}();
	
	module.exports = Transmitter;

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Receiver = function () {
	  function Receiver(global) {
	    var _this = this;
	
	    _classCallCheck(this, Receiver);
	
	    this.window = global;
	    this.messageHandlers = {};
	
	    this.window.addEventListener('message', function (event) {
	      try {
	        _this.handleMessage(_this.parseMessage(event.data), event);
	      } catch (e) {
	        return;
	      }
	    });
	  }
	
	  _createClass(Receiver, [{
	    key: 'parseMessage',
	    value: function parseMessage(message) {
	      if (typeof message === 'string') {
	        try {
	          message = JSON.parse(message);
	        } catch (e) {
	          throw new Error('Failed to parse message as JSON.');
	        }
	      }
	
	      if (!this.isObject(message)) {
	        throw new Error('Parsing the message should result an object.');
	      }
	
	      if (!message.hasOwnProperty('event')) {
	        throw new Error('Event name missing.');
	      }
	
	      if (typeof message.event !== 'string') {
	        throw new Error('Event name is not a string.');
	      }
	
	      if (!message.hasOwnProperty('source')) {
	        throw new Error('Message source missing.');
	      }
	
	      if (!this.isObject(message.source)) {
	        throw new Error('Message source is not an object.');
	      }
	
	      return message;
	    }
	  }, {
	    key: 'handleMessage',
	    value: function handleMessage(message, event) {
	      if (!this.messageHandlers[message.event]) {
	        return;
	      }
	
	      this.messageHandlers[message.event].forEach(function (handler) {
	        return handler.call(handler, message, event);
	      });
	    }
	  }, {
	    key: 'addMessageHandler',
	    value: function addMessageHandler(message, callback) {
	      if (!this.messageHandlers[message]) {
	        this.messageHandlers[message] = [];
	      }
	
	      this.messageHandlers[message].push(callback);
	    }
	  }, {
	    key: 'isObject',
	    value: function isObject(subject) {
	      var type = typeof subject === 'undefined' ? 'undefined' : _typeof(subject);
	      return type === 'function' || type === 'object' && !!subject;
	    }
	  }]);
	
	  return Receiver;
	}();
	
	module.exports = Receiver;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseApi = __webpack_require__(5);
	
	var AlertApi = function (_BaseApi) {
	  _inherits(AlertApi, _BaseApi);
	
	  function AlertApi() {
	    _classCallCheck(this, AlertApi);
	
	    return _possibleConstructorReturn(this, (AlertApi.__proto__ || Object.getPrototypeOf(AlertApi)).apply(this, arguments));
	  }
	
	  _createClass(AlertApi, [{
	    key: 'send',
	    value: function send(data) {
	      var defaultData = {
	        timeout: 1500
	      };
	
	      this.transmitter.messageToEmarsys('alert', Object.assign({}, defaultData, data));
	    }
	  }, {
	    key: 'log',
	    value: function log(text) {
	      this.send({
	        text: text
	      });
	    }
	  }, {
	    key: 'success',
	    value: function success(text) {
	      this.send({
	        text: text,
	        className: 'e-alert-success',
	        icon: 'check'
	      });
	    }
	  }, {
	    key: 'info',
	    value: function info(text) {
	      this.send({
	        text: text,
	        className: 'e-alert-info',
	        icon: 'e-info-circle'
	      });
	    }
	  }, {
	    key: 'warn',
	    value: function warn(text) {
	      this.send({
	        text: text,
	        className: 'e-alert-warning',
	        icon: 'exclamation-circle',
	        timeout: 5000
	      });
	    }
	  }, {
	    key: 'error',
	    value: function error(text) {
	      this.send({
	        text: text,
	        className: 'e-alert-danger',
	        icon: 'exclamation-circle',
	        timeout: 5000
	      });
	    }
	  }], [{
	    key: 'create',
	    value: function create(transmitter) {
	      var api = new AlertApi(transmitter);
	
	      return api.exposeMethods(['send', 'log', 'success', 'info', 'warn', 'error']);
	    }
	  }]);
	
	  return AlertApi;
	}(BaseApi);
	
	module.exports = AlertApi;

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BaseApi = function () {
	  _createClass(BaseApi, null, [{
	    key: 'EMARSYS',
	    get: function get() {
	      return 'EMARSYS';
	    }
	  }]);
	
	  function BaseApi(transmitter) {
	    _classCallCheck(this, BaseApi);
	
	    this.transmitter = transmitter;
	  }
	
	  _createClass(BaseApi, [{
	    key: 'getRandomId',
	    value: function getRandomId() {
	      return Math.floor(Math.random() * 10000000);
	    }
	  }, {
	    key: 'exposeMethods',
	    value: function exposeMethods(methodList) {
	      var _this = this;
	
	      return methodList.reduce(function (memo, methodName) {
	        memo[methodName] = _this[methodName].bind(_this);
	        return memo;
	      }, {});
	    }
	  }]);
	
	  return BaseApi;
	}();
	
	module.exports = BaseApi;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defer = __webpack_require__(7);
	
	var BaseApi = __webpack_require__(5);
	
	var DialogApi = function (_BaseApi) {
	  _inherits(DialogApi, _BaseApi);
	
	  _createClass(DialogApi, [{
	    key: 'params',
	    get: function get() {
	      return JSON.parse(document.body.getAttribute('data-params'));
	    }
	  }]);
	
	  function DialogApi(transmitter, receiver) {
	    _classCallCheck(this, DialogApi);
	
	    var _this = _possibleConstructorReturn(this, (DialogApi.__proto__ || Object.getPrototypeOf(DialogApi)).call(this, transmitter));
	
	    _this.deferreds = {};
	    receiver.addMessageHandler('dialog:submit', _this.handleSubmit.bind(_this));
	    return _this;
	  }
	
	  _createClass(DialogApi, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(message) {
	      if (this.deferreds[message.data.dialogId]) {
	        if (message.data.success) {
	          this.deferreds[message.data.dialogId].resolve(message);
	        } else {
	          this.deferreds[message.data.dialogId].reject(message);
	        }
	
	        if (message.data.autoClose !== false) {
	          this.close();
	        }
	      }
	    }
	  }, {
	    key: 'modal',
	    value: function modal(options) {
	      return this.dialog('modal', options);
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm(options) {
	      return this.dialog('confirm', options);
	    }
	  }, {
	    key: 'dialog',
	    value: function dialog(dialogType, options) {
	      options.dialogId = this.getRandomId();
	      this.deferreds[options.dialogId] = defer();
	
	      this.transmitter.messageToEmarsys(dialogType, options);
	      return this.deferreds[options.dialogId].promise;
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.transmitter.messageToEmarsys('modal:close');
	    }
	  }, {
	    key: 'submit',
	    value: function submit(success, data) {
	      data = data || {};
	      var message = this.generateMessageData(success, data);
	      this.transmitter.messageToService('dialog:submit', message, this.params.openerIntegrationInstanceId);
	    }
	  }, {
	    key: 'generateMessageData',
	    value: function generateMessageData(success, data) {
	      data = data || {};
	
	      return Object.assign({
	        dialogId: this.params.dialogId,
	        success: success
	      }, data);
	    }
	  }], [{
	    key: 'create',
	    value: function create(transmitter, receiver) {
	      var api = new DialogApi(transmitter, receiver);
	
	      return api.exposeMethods(['confirm', 'close', 'modal', 'submit']);
	    }
	  }]);
	
	  return DialogApi;
	}(BaseApi);
	
	module.exports = DialogApi;

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
	  var deferred = {};
	  deferred.promise = new Promise(function (resolve, reject) {
	    deferred.resolve = resolve;
	    deferred.reject = reject;
	  });
	
	  return deferred;
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseApi = __webpack_require__(5);
	var defer = __webpack_require__(7);
	
	var MiscApi = function (_BaseApi) {
	  _inherits(MiscApi, _BaseApi);
	
	  function MiscApi(transmitter, receiver) {
	    _classCallCheck(this, MiscApi);
	
	    var _this = _possibleConstructorReturn(this, (MiscApi.__proto__ || Object.getPrototypeOf(MiscApi)).call(this, transmitter));
	
	    _this.deferreds = {};
	    _this.timeoutIds = {};
	    receiver.addMessageHandler('navigate:response', _this.handleResponse.bind(_this));
	    receiver.addMessageHandler('get_url:response', _this.handleResponse.bind(_this));
	    return _this;
	  }
	
	  _createClass(MiscApi, [{
	    key: 'handleResponse',
	    value: function handleResponse(message) {
	      if (message.source.integration_id === BaseApi.EMARSYS) {
	        if (this.deferreds[message.data.id]) {
	          clearTimeout(this.timeoutIds[message.data.id]);
	          if (message.data.success) {
	            this.deferreds[message.data.id].resolve(message);
	          } else {
	            this.deferreds[message.data.id].reject(message);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'fit',
	    value: function fit() {
	      this.transmitter.messageToEmarsys('fit');
	    }
	  }, {
	    key: 'resize',
	    value: function resize(height) {
	      this.transmitter.messageToEmarsys('resize', {
	        height: height
	      });
	    }
	  }, {
	    key: 'track',
	    value: function track(options) {
	      this.transmitter.messageToEmarsys('track', options);
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.transmitter.messageToEmarsys('refresh', {});
	    }
	  }, {
	    key: 'enableButton',
	    value: function enableButton(selector) {
	      this.transmitter.messageToEmarsys('enable_button', {
	        selector: selector
	      });
	    }
	  }, {
	    key: 'navigate',
	    value: function navigate(eventPayload) {
	      return this.sendMessage('navigate', eventPayload);
	    }
	  }, {
	    key: 'getUrl',
	    value: function getUrl(eventPayload) {
	      return this.sendMessage('get_url', eventPayload);
	    }
	  }, {
	    key: 'sendMessage',
	    value: function sendMessage(eventName, eventPayload) {
	      var _this2 = this;
	
	      var eventId = this.getRandomId();
	      this.deferreds[eventId] = defer();
	
	      this.timeoutIds[eventId] = setTimeout(function () {
	        console.error('No response received for integrationClient request within ' + _this2.getResponseTimeout() + 'ms. Make sure emarsys-integration-js is included in the top iframe.');
	        var myWindow = _this2.transmitter.global;
	        var isIFrame = myWindow.self !== myWindow.top;
	        var errorMessage = void 0;
	        if (!isIFrame && (!myWindow.Emarsys || !myWindow.Emarsys.integration)) {
	          errorMessage = 'No response received for integrationClient within timeout, emarsys-integration-js is missing';
	        } else {
	          errorMessage = 'No response received for integrationClient within timeout';
	        }
	        _this2.deferreds[eventId].reject(new Error(errorMessage));
	      }, this.getResponseTimeout());
	
	      this.transmitter.messageToEmarsys(eventName, Object.assign({}, eventPayload, { eventId: eventId }));
	      return this.deferreds[eventId].promise;
	    }
	  }, {
	    key: 'getResponseTimeout',
	    value: function getResponseTimeout() {
	      return 2000;
	    }
	  }], [{
	    key: 'create',
	    value: function create(transmitter, receiver) {
	      var api = new MiscApi(transmitter, receiver);
	
	      return api.exposeMethods(['enableButton', 'fit', 'getUrl', 'navigate', 'refresh', 'resize', 'track']);
	    }
	  }]);
	
	  return MiscApi;
	}(BaseApi);
	
	module.exports = MiscApi;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseApi = __webpack_require__(5);
	
	var UnloadApi = function (_BaseApi) {
	  _inherits(UnloadApi, _BaseApi);
	
	  function UnloadApi() {
	    _classCallCheck(this, UnloadApi);
	
	    return _possibleConstructorReturn(this, (UnloadApi.__proto__ || Object.getPrototypeOf(UnloadApi)).apply(this, arguments));
	  }
	
	  _createClass(UnloadApi, [{
	    key: 'init',
	    value: function init(options) {
	      this.transmitter.messageToEmarsys('unload:init', options);
	    }
	  }, {
	    key: 'reset',
	    value: function reset(selector) {
	      this.transmitter.messageToEmarsys('unload:reset', {
	        selector: selector
	      });
	    }
	  }], [{
	    key: 'create',
	    value: function create(transmitter) {
	      var api = new UnloadApi(transmitter);
	
	      return api.exposeMethods(['init', 'reset']);
	    }
	  }]);
	
	  return UnloadApi;
	}(BaseApi);
	
	module.exports = UnloadApi;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseApi = __webpack_require__(5);
	
	var UpdateHashApi = function (_BaseApi) {
	  _inherits(UpdateHashApi, _BaseApi);
	
	  function UpdateHashApi() {
	    _classCallCheck(this, UpdateHashApi);
	
	    return _possibleConstructorReturn(this, (UpdateHashApi.__proto__ || Object.getPrototypeOf(UpdateHashApi)).apply(this, arguments));
	  }
	
	  _createClass(UpdateHashApi, [{
	    key: 'set',
	    value: function set(hash) {
	      this.transmitter.messageToEmarsys('update_hash', { hash: hash });
	    }
	  }], [{
	    key: 'create',
	    value: function create(transmitter) {
	      var api = new UpdateHashApi(transmitter);
	
	      return api.exposeMethods(['set']);
	    }
	  }]);
	
	  return UpdateHashApi;
	}(BaseApi);
	
	module.exports = UpdateHashApi;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseApi = __webpack_require__(5);
	
	var IntercomApi = function (_BaseApi) {
	  _inherits(IntercomApi, _BaseApi);
	
	  function IntercomApi() {
	    _classCallCheck(this, IntercomApi);
	
	    return _possibleConstructorReturn(this, (IntercomApi.__proto__ || Object.getPrototypeOf(IntercomApi)).apply(this, arguments));
	  }
	
	  _createClass(IntercomApi, [{
	    key: 'trackEvent',
	    value: function trackEvent(name, metadata) {
	      this.transmitter.messageToEmarsys('intercom:track_event', { name: name, metadata: metadata });
	    }
	  }], [{
	    key: 'create',
	    value: function create(transmitter) {
	      var api = new IntercomApi(transmitter);
	
	      return api.exposeMethods(['trackEvent']);
	    }
	  }]);
	
	  return IntercomApi;
	}(BaseApi);
	
	module.exports = IntercomApi;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(13);


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(14),
	    createAssigner = __webpack_require__(33),
	    keysIn = __webpack_require__(46);
	
	/**
	 * This method is like `_.assign` except that it iterates over own and
	 * inherited source properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assign
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	 */
	var assignIn = createAssigner(function(object, source) {
	  copyObject(source, keysIn(source), object);
	});
	
	module.exports = assignIn;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(15),
	    baseAssignValue = __webpack_require__(16);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(16),
	    eq = __webpack_require__(32);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(17);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(18);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(19),
	    getValue = __webpack_require__(31);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(20),
	    isMasked = __webpack_require__(28),
	    isObject = __webpack_require__(27),
	    toSource = __webpack_require__(30);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(21),
	    isObject = __webpack_require__(27);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(22),
	    getRawTag = __webpack_require__(25),
	    objectToString = __webpack_require__(26);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(23);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(24);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 24 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(22);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 26 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 27 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(29);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(23);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 30 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 31 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 32 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(34),
	    isIterateeCall = __webpack_require__(42);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(35),
	    overRest = __webpack_require__(36),
	    setToString = __webpack_require__(38);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 35 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(37);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(39),
	    shortOut = __webpack_require__(41);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(40),
	    defineProperty = __webpack_require__(17),
	    identity = __webpack_require__(35);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 40 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 41 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(32),
	    isArrayLike = __webpack_require__(43),
	    isIndex = __webpack_require__(45),
	    isObject = __webpack_require__(27);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(20),
	    isLength = __webpack_require__(44);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 44 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 45 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(47),
	    baseKeysIn = __webpack_require__(60),
	    isArrayLike = __webpack_require__(43);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(48),
	    isArguments = __webpack_require__(49),
	    isArray = __webpack_require__(52),
	    isBuffer = __webpack_require__(53),
	    isIndex = __webpack_require__(45),
	    isTypedArray = __webpack_require__(56);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 48 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(50),
	    isObjectLike = __webpack_require__(51);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(21),
	    isObjectLike = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 51 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 52 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(23),
	    stubFalse = __webpack_require__(55);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)(module)))

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 55 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(57),
	    baseUnary = __webpack_require__(58),
	    nodeUtil = __webpack_require__(59);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(21),
	    isLength = __webpack_require__(44),
	    isObjectLike = __webpack_require__(51);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 58 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(24);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)(module)))

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(27),
	    isPrototype = __webpack_require__(61),
	    nativeKeysIn = __webpack_require__(62);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 61 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 62 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 63 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var Logger = function () {
	  function Logger() {
	    _classCallCheck(this, Logger);
	  }
	
	  _createClass(Logger, null, [{
	    key: 'sendLog',
	    value: function sendLog(action) {
	      var additional = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (!window.e || !window.e.utils || !window.e.utils.sendLog || !window.e.utils.getCurrentConfig) {
	        return;
	      };
	
	      window.e.utils.getTopUrl().then(function (url) {
	        var list = {};
	        var topFrameUrl = new URL(url);
	        var searchParams = new URLSearchParams(topFrameUrl.search);
	
	        ['action', 'r', 'service', 'service_product', 'show', 'step', 'from_action'].forEach(function (key) {
	          var value = searchParams.get(key);
	
	          if (value) {
	            list[key] = JSON.stringify(value);
	          }
	        });
	
	        if (window.currentMenuItem) {
	          list.currentMenuItem = {
	            main: window.currentMenuItem.mainMenuItem && window.currentMenuItem.mainMenuItem.id,
	            sub: window.currentMenuItem.submenuItem && window.currentMenuItem.submenuItem.id
	          };
	        }
	
	        list.additional = JSON.stringify(additional);
	
	        window.e.utils.sendLog({
	          action: action,
	          level: 30,
	          'service-name': 'emarsys-integration-js',
	          name: 'emarsys-integration-js',
	          user: Logger._getUserData(),
	          time: new Date().toISOString(),
	          referrer: Logger._getReferrer(),
	          page_load_id: String(Math.random()),
	          debug_data: JSON.stringify(list)
	        });
	      });
	    }
	  }, {
	    key: '_getReferrer',
	    value: function _getReferrer() {
	      return [window.document.referrer, window.document.location.href].map(function (url) {
	        return url.split('?')[0];
	      }).filter(function (url) {
	        return url.length > 0;
	      });
	    }
	  }, {
	    key: '_getUserData',
	    value: function _getUserData() {
	      var userConfig = window.e.utils.getCurrentConfig();
	      return {
	        customer_id: userConfig.customerId,
	        admin_id: userConfig.adminId,
	        date_format: userConfig.dateFormat,
	        time_format: userConfig.timeFormat,
	        language: userConfig.language,
	        timezone: userConfig.timezone
	      };
	    }
	  }]);
	
	  return Logger;
	}();
	
	module.exports = Logger;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var ServiceTransmitter = __webpack_require__(1).comm.Transmitter;
	
	var Transmitter = function (_ServiceTransmitter) {
	  _inherits(Transmitter, _ServiceTransmitter);
	
	  function Transmitter() {
	    _classCallCheck(this, Transmitter);
	
	    return _possibleConstructorReturn(this, (Transmitter.__proto__ || Object.getPrototypeOf(Transmitter)).apply(this, arguments));
	  }
	
	  _createClass(Transmitter, [{
	    key: 'sendMessage',
	    value: function sendMessage(message, integrationInstanceId) {
	      console.log('Method integration.sendMessage() is deprecated. Use integration.messageToService() instead.');
	      this.messageToService(message, integrationInstanceId);
	    }
	  }, {
	    key: 'messageToEmarsys',
	    value: function messageToEmarsys(eventName, data) {
	      this.global.postMessage(JSON.stringify(this.setMessageSource(this.compileMessage(eventName, data))), '*');
	    }
	  }, {
	    key: 'messageToService',
	    value: function messageToService(eventName, data, targetInstanceId) {
	      var integrationInstance = this.global.$('#integration-' + targetInstanceId);
	      if (integrationInstance && integrationInstance.length) {
	        integrationInstance[0].contentWindow.postMessage(JSON.stringify(this.setMessageSource(this.compileMessage(eventName, data))), '*');
	      }
	    }
	  }, {
	    key: 'respondToSender',
	    value: function respondToSender(eventName, data, eventToRespondTo) {
	      eventToRespondTo.source.postMessage(JSON.stringify(this.setMessageSource(this.compileMessage(eventName, data))), '*');
	    }
	  }]);
	
	  return Transmitter;
	}(ServiceTransmitter);
	
	module.exports = Transmitter;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var Logger = __webpack_require__(63);
	var _extend = __webpack_require__(12);
	
	var DialogApi = function () {
	  _createClass(DialogApi, [{
	    key: 'params',
	    get: function get() {
	      return this._getParams();
	    }
	  }]);
	
	  function DialogApi(api, dialogFactory) {
	    _classCallCheck(this, DialogApi);
	
	    this.api = api;
	    this.dialogFactory = dialogFactory;
	    this.global = api.global;
	    this._currentDialog = null;
	
	    this.deferreds = {};
	    this.confirmParams = {};
	  }
	
	  _createClass(DialogApi, [{
	    key: 'submit',
	    value: function submit(success, data) {
	      Logger.sendLog('window dialog submit', { success: success, data: data });
	      data = data || {};
	      var message = this.generateMessageData(success, data);
	
	      if (this.deferreds[this.params.dialogId]) {
	        if (success) {
	          this.deferreds[this.params.dialogId].resolve(message);
	        } else {
	          this.deferreds[this.params.dialogId].reject(message);
	        }
	      } else {
	        this.api.messageToService('dialog:submit', message, this.params.openerIntegrationInstanceId);
	      }
	    }
	  }, {
	    key: 'generateMessageData',
	    value: function generateMessageData(success) {
	      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      Logger.sendLog('window dialog generateMessageData', { success: success, data: data });
	      var message = _extend({
	        dialogId: this.params.dialogId,
	        success: success
	      }, data);
	
	      if (this.confirmParams[this.params.dialogId]) {
	        return _extend(message, this.confirmParams[this.params.dialogId]);
	      }
	
	      return message;
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm(message) {
	      Logger.sendLog('window dialog confirm', { message: message });
	      if (!message.data.dialogId) {
	        message.data.dialogId = this._generateDialogId();
	      }
	
	      if (message.data.params) {
	        this.confirmParams[message.data.dialogId] = message.data.params;
	      }
	
	      this._currentDialog = this.dialogFactory.createConfirmDialog(this.global, message);
	      this._currentDialog.render();
	
	      if (message.source.integration_id === 'EMARSYS') {
	        this.deferreds[message.data.dialogId] = this.global.$.Deferred(); // eslint-disable-line new-cap
	        return this.deferreds[message.data.dialogId].promise();
	      }
	    }
	  }, {
	    key: 'confirmNavigation',
	    value: function confirmNavigation(url, message) {
	      var _this = this;
	
	      Logger.sendLog('window dialog confirmNavigation', { url: url, message: message });
	      var confirmPromise = this.confirm(message);
	
	      confirmPromise.done(function () {
	        _this.global.$(_this.global).off('beforeunload');
	        _this.global.location.href = url;
	      }).fail(function () {
	        _this.close();
	      });
	
	      return confirmPromise;
	    }
	  }, {
	    key: 'modal',
	    value: function modal(message) {
	      Logger.sendLog('window dialog modal', { message: message });
	      this._currentDialog = this.dialogFactory.createModalDialog(this.global, message);
	      this._currentDialog.render();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      Logger.sendLog('window dialog close');
	      this._currentDialog && this._currentDialog.close();
	    }
	  }, {
	    key: '_generateDialogId',
	    value: function _generateDialogId() {
	      return Math.floor(Math.random() * 10000000);
	    }
	  }, {
	    key: '_getParams',
	    value: function _getParams() {
	      if (!this._currentDialog) {
	        return {};
	      }
	
	      return JSON.parse(this._currentDialog.getAttribute('data-params'));
	    }
	  }]);
	
	  return DialogApi;
	}();
	
	module.exports = DialogApi;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var Logger = __webpack_require__(63);
	var Confirm = __webpack_require__(67);
	var Modal = __webpack_require__(69);
	
	var DialogFactory = function () {
	  function DialogFactory() {
	    _classCallCheck(this, DialogFactory);
	  }
	
	  _createClass(DialogFactory, [{
	    key: 'createConfirmDialog',
	    value: function createConfirmDialog(global, message) {
	      return new Confirm(global, message);
	    }
	  }, {
	    key: 'createModalDialog',
	    value: function createModalDialog(global, message) {
	      return new Modal(global, message);
	    }
	  }], [{
	    key: 'create',
	    value: function create() {
	      Logger.sendLog('window dialog factory create');
	      return new DialogFactory();
	    }
	  }]);
	
	  return DialogFactory;
	}();
	
	module.exports = DialogFactory;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var Dialog = __webpack_require__(68);
	
	var Confirm = function (_Dialog) {
	  _inherits(Confirm, _Dialog);
	
	  function Confirm() {
	    _classCallCheck(this, Confirm);
	
	    return _possibleConstructorReturn(this, (Confirm.__proto__ || Object.getPrototypeOf(Confirm)).apply(this, arguments));
	  }
	
	  _createClass(Confirm, [{
	    key: 'render',
	    value: function render() {
	      _get(Confirm.prototype.__proto__ || Object.getPrototypeOf(Confirm.prototype), 'render', this).call(this);
	
	      var $eModal = this.window.$(this._modal);
	      $eModal.attr('data-params', JSON.stringify({
	        integrationId: this.options.source.integration_id,
	        integrationInstanceId: 'EMARSYS',
	        openerIntegrationInstanceId: this.options.source.integration_instance_id,
	        dialogId: this.options.data.dialogId
	      }));
	    }
	  }, {
	    key: 'getModalOptions',
	    value: function getModalOptions() {
	      var _modalOptions$buttons;
	
	      var modalOptions = _get(Confirm.prototype.__proto__ || Object.getPrototypeOf(Confirm.prototype), 'getModalOptions', this).call(this);
	      var cancelButton = this.cleanMessage(this.options.data.cancel);
	      var okButton = this.cleanMessage(this.options.data.ok);
	      modalOptions.buttons = (_modalOptions$buttons = {}, _defineProperty(_modalOptions$buttons, cancelButton, {
	        autofocus: true,
	        callback: function callback() {
	          window.Emarsys.integration.dialog.submit(false);
	        },
	        className: 'e-flex__item'
	      }), _defineProperty(_modalOptions$buttons, okButton, {
	        callback: function callback() {
	          window.Emarsys.integration.dialog.submit(true);
	        },
	        className: 'e-flex__item e-btn-primary background-color-danger'
	      }), _modalOptions$buttons);
	
	      return modalOptions;
	    }
	  }, {
	    key: 'getModalContent',
	    value: function getModalContent() {
	      if (this.options.data.body) {
	        return this.cleanMessage(this.options.data.body);
	      }
	
	      return '';
	    }
	  }]);
	
	  return Confirm;
	}(Dialog);
	
	module.exports = Confirm;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 68 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var Dialog = function () {
	  function Dialog(global, options) {
	    _classCallCheck(this, Dialog);
	
	    this.window = global;
	    this.options = options;
	    this.integrationInstanceId = Math.floor(Math.random() * 1000000000);
	  }
	
	  _createClass(Dialog, [{
	    key: 'render',
	    value: function render() {
	      this._modal = this.getHtml();
	      this._modal.open(this.getModalOptions());
	    }
	  }, {
	    key: 'getModalOptions',
	    value: function getModalOptions() {
	      var modalOptions = {
	        headline: this.options.data.title,
	        width: this.options.data.width + 'px',
	        content: this.getModalContent()
	      };
	
	      return modalOptions;
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this._modal.close();
	    }
	  }, {
	    key: 'getAttribute',
	    value: function getAttribute(attributeName) {
	      return this._modal.getAttribute(attributeName);
	    }
	  }, {
	    key: 'getHtml',
	    value: function getHtml() {
	      var eDialog = document.createElement('e-dialog');
	      eDialog.className = this.dialogClass;
	      return eDialog;
	    }
	  }, {
	    key: 'cleanMessage',
	    value: function cleanMessage(text) {
	      return this.window.$('<div>' + text + '</div>').text();
	    }
	  }, {
	    key: 'dialogClass',
	    get: function get() {
	      return '';
	    }
	  }]);
	
	  return Dialog;
	}();
	
	module.exports = Dialog;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var _extend = __webpack_require__(12);
	var Dialog = __webpack_require__(68);
	
	var Modal = function (_Dialog) {
	  _inherits(Modal, _Dialog);
	
	  _createClass(Modal, [{
	    key: 'dialogClass',
	    get: function get() {
	      return 'e-dialog-iframe';
	    }
	  }]);
	
	  function Modal(global, options) {
	    _classCallCheck(this, Modal);
	
	    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, global, options));
	
	    _this.options.data = _extend({
	      width: 650,
	      height: 500
	    }, _this.options.data);
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      _get(Modal.prototype.__proto__ || Object.getPrototypeOf(Modal.prototype), 'render', this).call(this);
	
	      var $eModal = $(this._modal);
	      $eModal.css('opacity', 0);
	      $eModal.find('iframe').load(function () {
	        _this2.window.setTimeout(function () {
	          $eModal.css('opacity', 1);
	        }, 0);
	      });
	    }
	  }, {
	    key: 'getAttributes',
	    value: function getAttributes() {
	      var _this3 = this;
	
	      var attributes = ['frameborder="0"', 'class="integration integration-' + this.options.source.integration_id + '"', 'id="integration-' + this.integrationInstanceId + '"'];
	
	      ['src', 'width', 'height'].forEach(function (attributeName) {
	        attributes.push(attributeName + '="' + _this3.options.data[attributeName] + '"');
	      });
	
	      return attributes;
	    }
	  }, {
	    key: 'decorateUrl',
	    value: function decorateUrl() {
	      var glue = this.options.data.src.indexOf('?') < 0 ? '?' : '&';
	
	      var params = ['dialogId=' + this.options.data.dialogId, 'integration_id=' + this.options.source.integration_id, 'integration_instance_id=' + this.integrationInstanceId, 'opener_integration_instance_id=' + this.options.source.integration_instance_id];
	
	      return this.options.data.src + glue + params.join('&');
	    }
	  }, {
	    key: 'getModalOptions',
	    value: function getModalOptions() {
	      var modalOptions = _get(Modal.prototype.__proto__ || Object.getPrototypeOf(Modal.prototype), 'getModalOptions', this).call(this);
	      modalOptions.height = this.options.data.height + 'px';
	
	      return modalOptions;
	    }
	  }, {
	    key: 'getModalContent',
	    value: function getModalContent() {
	      this.options.data.src = this.decorateUrl();
	
	      return '<iframe ' + this.getAttributes().join(' ') + '></iframe>';
	    }
	  }]);
	
	  return Modal;
	}(Dialog);
	
	module.exports = Modal;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	module.exports = function (global) {
	  var ConnectCoreAPI = __webpack_require__(71).create(global.Emarsys, global);
	
	  ConnectCoreAPI.personalization = __webpack_require__(72).create(global.Emarsys, global);
	  ConnectCoreAPI.conditional = __webpack_require__(78).create(global.Emarsys, global);
	  ConnectCoreAPI.mediaDb = __webpack_require__(79).create(global.Emarsys, global);
	  ConnectCoreAPI.fullPreview = __webpack_require__(80).create(global.Emarsys, global);
	
	  global.Emarsys.integration.contentEditor = ConnectCoreAPI;
	  if (global.SUITE && global.SUITE.integration) {
	    global.SUITE.integration.contentEditor = ConnectCoreAPI;
	  }
	};
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 71 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var ConnectCore = function () {
	  function ConnectCore(SuiteAPI, global) {
	    _classCallCheck(this, ConnectCore);
	
	    this.SuiteAPI = SuiteAPI;
	    this.global = global;
	  }
	
	  _createClass(ConnectCore, [{
	    key: 'save',
	    value: function save(integrationInstanceId) {
	      var saveButton = document.getElementById('content-save-button');
	      if (saveButton.classList.contains('e-btn-disabled')) {
	        return;
	      }
	
	      saveButton.classList.add('e-btn-disabled');
	      this.global.Emarsys.integration.messageToService('save', {}, integrationInstanceId);
	    }
	  }, {
	    key: 'feedback',
	    value: function feedback(integrationInstanceId) {
	      this.global.Emarsys.integration.messageToService('feedback', {}, integrationInstanceId);
	    }
	  }], [{
	    key: 'create',
	    value: function create(SuiteAPI, global) {
	      return new ConnectCore(SuiteAPI, global);
	    }
	  }]);
	
	  return ConnectCore;
	}();
	
	module.exports = ConnectCore;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var AbstractInsertable = __webpack_require__(73);
	var Logger = __webpack_require__(63);
	
	var InsertablePersonalization = function (_AbstractInsertable) {
	  _inherits(InsertablePersonalization, _AbstractInsertable);
	
	  function InsertablePersonalization() {
	    _classCallCheck(this, InsertablePersonalization);
	
	    return _possibleConstructorReturn(this, (InsertablePersonalization.__proto__ || Object.getPrototypeOf(InsertablePersonalization)).apply(this, arguments));
	  }
	
	  _createClass(InsertablePersonalization, [{
	    key: '_openDialog',
	    value: function _openDialog() {
	      this.Window.callMethod('openDialog', 'personalizer.php?session_id=$SID$&camp=$CAMPAIGNID$&func=' + this.insertCallbackName, 300, 350);
	    }
	  }, {
	    key: '_getInsertMessage',
	    value: function _getInsertMessage(variable) {
	      return {
	        variable: this._prepareVariable(variable)
	      };
	    }
	  }, {
	    key: 'EVENT_NAMESPACE',
	    get: function get() {
	      return 'personalization';
	    }
	  }, {
	    key: 'EVENT_OPEN',
	    get: function get() {
	      return 'open';
	    }
	  }, {
	    key: 'EVENT_INSERT',
	    get: function get() {
	      return 'insertVariable';
	    }
	  }], [{
	    key: 'create',
	    value: function create(SuiteAPI, global) {
	      Logger.sendLog('window contentEditor ConnectCoreAPI personalization');
	      return new InsertablePersonalization(SuiteAPI, global);
	    }
	  }]);
	
	  return InsertablePersonalization;
	}(AbstractInsertable);
	
	module.exports = InsertablePersonalization;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var AbstractOpenable = __webpack_require__(74);
	
	var AbstractInsertable = function (_AbstractOpenable) {
	  _inherits(AbstractInsertable, _AbstractOpenable);
	
	  function AbstractInsertable() {
	    _classCallCheck(this, AbstractInsertable);
	
	    return _possibleConstructorReturn(this, (AbstractInsertable.__proto__ || Object.getPrototypeOf(AbstractInsertable)).apply(this, arguments));
	  }
	
	  _createClass(AbstractInsertable, [{
	    key: 'open',
	    value: function open(data) {
	      this._clearAllGlobalCallbacks();
	
	      this._generateInsertCallbackName();
	      this.Window.createCallback(this.insertCallbackName, this._insertCallback.bind(this, data.source.integration_instance_id), this);
	
	      if (this.EVENT_CHANGE) {
	        this._generateChangeCallbackName();
	        this.Window.createCallback(this.changeCallbackName, this._changeCallback.bind(this, data.source.integration_instance_id), this);
	      }
	
	      _get(AbstractInsertable.prototype.__proto__ || Object.getPrototypeOf(AbstractInsertable.prototype), 'open', this).call(this, data); // eslint-disable-line security/detect-non-literal-fs-filename
	    }
	  }, {
	    key: '_clearAllGlobalCallbacks',
	    value: function _clearAllGlobalCallbacks() {
	      for (var globalMember in this.Window.global) {
	        if (globalMember.toString().match(AbstractInsertable.ceCallbackPattern)) {
	          try {
	            delete this.Window.global[globalMember];
	          } catch (event) {
	            this.Window.global[globalMember] = null;
	          }
	        }
	      }
	    }
	  }, {
	    key: '_insertCallback',
	    value: function _insertCallback(integrationInstanceId) {
	      var args = Array.prototype.splice.call(arguments, 1);
	      var insertData = this._getInsertMessage.apply(this, args);
	
	      this.Window.global.Emarsys.integration[this._getTransmitMethod(integrationInstanceId)](this._prepareEventName(this.EVENT_INSERT), insertData, integrationInstanceId);
	    }
	  }, {
	    key: '_changeCallback',
	    value: function _changeCallback(integrationInstanceId) {
	      this.Window.global.Emarsys.integration[this._getTransmitMethod(integrationInstanceId)](this._prepareEventName(this.EVENT_CHANGE), false, integrationInstanceId);
	    }
	  }, {
	    key: '_getTransmitMethod',
	    value: function _getTransmitMethod(integrationInstanceId) {
	      if (integrationInstanceId === 'EMARSYS') {
	        return 'messageToEmarsys';
	      }
	
	      return 'messageToService';
	    }
	  }, {
	    key: '_getInsertMessage',
	    value: function _getInsertMessage() {
	      throw new Error('This method should be implemented.');
	    }
	  }, {
	    key: '_generateInsertCallbackName',
	    value: function _generateInsertCallbackName() {
	      var callbackName = this._generateCallbackName('Insert');
	      this._validateCallbackName(callbackName);
	      this.insertCallbackName = callbackName;
	    }
	  }, {
	    key: '_generateChangeCallbackName',
	    value: function _generateChangeCallbackName() {
	      var callbackName = this._generateCallbackName('Change');
	      this._validateCallbackName(callbackName);
	      this.changeCallbackName = callbackName;
	    }
	  }, {
	    key: '_validateCallbackName',
	    value: function _validateCallbackName(callbackName) {
	      if (!callbackName.match(AbstractInsertable.ceCallbackPattern)) {
	        throw new Error('Invalid callback name!');
	      }
	    }
	  }, {
	    key: '_generateCallbackName',
	    value: function _generateCallbackName(name) {
	      return 'ce' + name + 'Callback' + this._generateId();
	    }
	  }, {
	    key: '_generateId',
	    value: function _generateId() {
	      return parseInt(Math.random() * 1000, 10);
	    }
	  }, {
	    key: '_prepareVariable',
	    value: function _prepareVariable(variable) {
	      return this.CampaignAPI.persPrefix + variable + this.CampaignAPI.persSuffix;
	    }
	  }], [{
	    key: 'ceCallbackPattern',
	    get: function get() {
	      return (/ce[a-zA-Z]+Callback\d+/
	      );
	    }
	  }]);
	
	  return AbstractInsertable;
	}(AbstractOpenable);
	
	module.exports = AbstractInsertable;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var WrapperCampaign = __webpack_require__(75);
	var WrapperConfig = __webpack_require__(76);
	var WrapperWindow = __webpack_require__(77);
	
	var AbstractOpenable = function () {
	  function AbstractOpenable(SuiteAPI, global) {
	    _classCallCheck(this, AbstractOpenable);
	
	    this.SuiteAPI = SuiteAPI;
	    this.global = global;
	    this.CampaignAPI = WrapperCampaign.create(this.SuiteAPI, this.global);
	    this.ConfigAPI = WrapperConfig.create(this.SuiteAPI, this.global);
	    this.Window = WrapperWindow.create(this.global);
	
	    this.global.Emarsys.integration.addMessageHandler(this._prepareEventName(this.EVENT_OPEN), this.open.bind(this));
	  }
	
	  _createClass(AbstractOpenable, [{
	    key: 'open',
	    value: function open(message) {
	      this._openDialog(message);
	    }
	  }, {
	    key: '_openDialog',
	    value: function _openDialog() {
	      throw new Error('This method should be implemented.');
	    }
	  }, {
	    key: '_prepareEventName',
	    value: function _prepareEventName(eventName) {
	      return this.EVENT_NAMESPACE + ':' + eventName;
	    }
	  }]);
	
	  return AbstractOpenable;
	}();
	
	module.exports = AbstractOpenable;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 75 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var WrapperCampaign = function () {
	  function WrapperCampaign() {
	    _classCallCheck(this, WrapperCampaign);
	  }
	
	  _createClass(WrapperCampaign, null, [{
	    key: 'create',
	    value: function create(SuiteAPI) {
	      return SuiteAPI.campaign || {
	        id: null,
	        persPrefix: '$',
	        persSuffix: '$'
	      };
	    }
	  }]);
	
	  return WrapperCampaign;
	}();
	
	module.exports = WrapperCampaign;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 76 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var WrapperConfig = function () {
	  function WrapperConfig() {
	    _classCallCheck(this, WrapperConfig);
	  }
	
	  _createClass(WrapperConfig, null, [{
	    key: 'create',
	    value: function create(SuiteAPI) {
	      if (!SuiteAPI.config) {
	        throw new Error('No Config found in SuiteAPI.');
	      }
	
	      return SuiteAPI.config;
	    }
	  }]);
	
	  return WrapperConfig;
	}();
	
	module.exports = WrapperConfig;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 77 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var WrapperWindow = function () {
	  function WrapperWindow(global) {
	    _classCallCheck(this, WrapperWindow);
	
	    this.global = global;
	  }
	
	  _createClass(WrapperWindow, [{
	    key: 'callMethod',
	    value: function callMethod(methodName) {
	      var args = Array.prototype.slice.call(arguments, 1);
	      this.global[methodName].apply(this.global, args);
	    }
	  }, {
	    key: 'createCallback',
	    value: function createCallback(name, callback, context) {
	      this.global[name] = this._createOneTimeCallbackForName(callback, context);
	    }
	  }, {
	    key: 'getGlobalMethod',
	    value: function getGlobalMethod(methodName) {
	      return this.global[methodName];
	    }
	  }, {
	    key: 'getGlobal',
	    value: function getGlobal(name) {
	      return this.global[name];
	    }
	  }, {
	    key: '_createOneTimeCallbackForName',
	    value: function _createOneTimeCallbackForName(callback, context) {
	      return function () {
	        callback.apply(context, arguments);
	      };
	    }
	  }], [{
	    key: 'create',
	    value: function create(global) {
	      global = global || window;
	      return new WrapperWindow(global);
	    }
	  }]);
	
	  return WrapperWindow;
	}();
	
	module.exports = WrapperWindow;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var AbstractInsertable = __webpack_require__(73);
	var Logger = __webpack_require__(63);
	
	var InsertableConditionalText = function (_AbstractInsertable) {
	  _inherits(InsertableConditionalText, _AbstractInsertable);
	
	  function InsertableConditionalText() {
	    _classCallCheck(this, InsertableConditionalText);
	
	    return _possibleConstructorReturn(this, (InsertableConditionalText.__proto__ || Object.getPrototypeOf(InsertableConditionalText)).apply(this, arguments));
	  }
	
	  _createClass(InsertableConditionalText, [{
	    key: '_openDialog',
	    value: function _openDialog() {
	      this.Window.callMethod('openDialog', this._getUrl(), 640, 480);
	    }
	  }, {
	    key: '_getUrl',
	    value: function _getUrl() {
	      return ['edit_cond_text.php?session_id=$SID$&camp=$CAMPAIGNID$&func=', this.insertCallbackName, '&funcSave=', this.changeCallbackName].join('');
	    }
	  }, {
	    key: '_getInsertMessage',
	    value: function _getInsertMessage(variable) {
	      return {
	        variable: this._prepareVariable(variable)
	      };
	    }
	  }, {
	    key: 'EVENT_NAMESPACE',
	    get: function get() {
	      return 'conditional';
	    }
	  }, {
	    key: 'EVENT_OPEN',
	    get: function get() {
	      return 'open';
	    }
	  }, {
	    key: 'EVENT_INSERT',
	    get: function get() {
	      return 'insertCondition';
	    }
	  }, {
	    key: 'EVENT_CHANGE',
	    get: function get() {
	      return 'changeConditionals';
	    }
	  }], [{
	    key: 'create',
	    value: function create(SuiteAPI, global) {
	      Logger.sendLog('window contentEditor ConnectCoreAPI conditional');
	      return new InsertableConditionalText(SuiteAPI, global);
	    }
	  }]);
	
	  return InsertableConditionalText;
	}(AbstractInsertable);
	
	module.exports = InsertableConditionalText;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var AbstractInsertable = __webpack_require__(73);
	var Logger = __webpack_require__(63);
	
	var InsertableMediaDb = function (_AbstractInsertable) {
	  _inherits(InsertableMediaDb, _AbstractInsertable);
	
	  function InsertableMediaDb() {
	    _classCallCheck(this, InsertableMediaDb);
	
	    return _possibleConstructorReturn(this, (InsertableMediaDb.__proto__ || Object.getPrototypeOf(InsertableMediaDb)).apply(this, arguments));
	  }
	
	  _createClass(InsertableMediaDb, [{
	    key: '_openDialog',
	    value: function _openDialog() {
	      var openMediaDb = this.Window.getGlobalMethod('OpenMediaDBDialog');
	      if (openMediaDb) {
	        openMediaDb(this.ConfigAPI.session_id, null, this.insertCallbackName, null, this.CampaignAPI.id, true);
	        return;
	      }
	
	      var mediaDB = this.Window.getGlobal('mediaDB') || {};
	      var mediaDBAPI = mediaDB.api;
	
	      if (!mediaDBAPI) {
	        return;
	      }
	
	      mediaDBAPI.once('fileSelected', this.Window.getGlobalMethod(this.callbackName));
	      mediaDBAPI.openWithFileSelection();
	    }
	  }, {
	    key: '_getInsertMessage',
	    value: function _getInsertMessage(id, originalFilename, relativePath, basePath) {
	      if (isNaN(id)) {
	        return {
	          originalName: id.originalFilename,
	          imageUrl: id.basePath + id.relativePath
	        };
	      }
	
	      return {
	        originalName: originalFilename,
	        imageUrl: basePath + relativePath
	      };
	    }
	  }, {
	    key: 'EVENT_NAMESPACE',
	    get: function get() {
	      return 'mediaDb';
	    }
	  }, {
	    key: 'EVENT_OPEN',
	    get: function get() {
	      return 'open';
	    }
	  }, {
	    key: 'EVENT_INSERT',
	    get: function get() {
	      return 'insertImage';
	    }
	  }], [{
	    key: 'create',
	    value: function create(SuiteAPI, global) {
	      Logger.sendLog('window contentEditor ConnectCoreAPI mediaDb');
	      return new InsertableMediaDb(SuiteAPI, global);
	    }
	  }]);
	
	  return InsertableMediaDb;
	}(AbstractInsertable);
	
	module.exports = InsertableMediaDb;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var AbstractOpenable = __webpack_require__(74);
	var Logger = __webpack_require__(63);
	
	var FullPreview = function (_AbstractOpenable) {
	  _inherits(FullPreview, _AbstractOpenable);
	
	  function FullPreview() {
	    _classCallCheck(this, FullPreview);
	
	    return _possibleConstructorReturn(this, (FullPreview.__proto__ || Object.getPrototypeOf(FullPreview)).apply(this, arguments));
	  }
	
	  _createClass(FullPreview, [{
	    key: '_openDialog',
	    value: function _openDialog() {
	      this.Window.callMethod('openDialog', this._getUrl(), 1024, 768);
	    }
	  }, {
	    key: '_getUrl',
	    value: function _getUrl() {
	      return 'preview_fs.php?session_id=$SID$&camp_id=$CAMPAIGNID$&show=html&force_mobile_preview=1';
	    }
	  }, {
	    key: 'EVENT_NAMESPACE',
	    get: function get() {
	      return 'preview';
	    }
	  }, {
	    key: 'EVENT_OPEN',
	    get: function get() {
	      return 'open';
	    }
	  }], [{
	    key: 'create',
	    value: function create(SuiteAPI, global) {
	      Logger.sendLog('window contentEditor ConnectCoreAPI fullPreview');
	      return new FullPreview(SuiteAPI, global);
	    }
	  }]);
	
	  return FullPreview;
	}(AbstractOpenable);
	
	module.exports = FullPreview;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var targets = __webpack_require__(82);
	
	var getUrlByTarget = function getUrlByTarget(pathname) {
	  if (pathname in targets) {
	    return targets[pathname];
	  }
	
	  throw new Error('Error 404: Unknown pathname');
	};
	
	var replaceUrlParams = function replaceUrlParams(url) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  for (var key in params) {
	    if (params.hasOwnProperty(key) && key !== 'pathname') {
	      url = url.replace('{' + key + '}', params[key]);
	    }
	  }
	
	  var regexForAnythingInBraces = /\{[^\{\}]*\}/g;
	  return url.replace(regexForAnythingInBraces, '');
	};
	
	module.exports = function (_ref) {
	  var sessionId = _ref.sessionId,
	      target = _ref.target,
	      _ref$params = _ref.params,
	      params = _ref$params === undefined ? {} : _ref$params;
	
	  params.session_id = sessionId;
	  return replaceUrlParams(getUrlByTarget(target), params);
	};
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 82 */
/***/ function(module, exports) {

	'use strict';
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	/**
	 * This routes list has a new place in the Suite as well.
	 * In the migration time please add your new routes also here and there. (suite: include/conf/navigation/routes.php)
	 * Our migration docs:
	 * https://emarsys.jira.com/wiki/spaces/DST/pages/4494000216/Migration+Guide+for+IFrame+Integration+Messaging
	 * If you have any question please reach out us in #team-design-system on Slack
	*/
	
	module.exports = {
	  'campaign_analytics/dashboard': ['bootstrap.php?session_id={session_id}', 'r=campaignAnalytics#/campaignAnalyticsDetails/{start_date}/{end_date}/{channel}/{campaign_id}'].join('&'),
	
	  'email_campaigns/list': ['campaignmanager.php?session_id={session_id}', 'action=list'].join('&'),
	
	  'email_campaigns/preview': ['preview_fs.php?session_id={session_id}', 'camp_id={campaign_id}'].join('&'),
	
	  'email_campaigns/create': ['campaignmanager.php?session_id={session_id}', 'action=new', 'use_template={use_template}', 'mailstream={mailstream}'].join('&'),
	
	  'email_campaigns/blocks/create': ['bootstrap.php?r=contentBlocks/selector&session_id={session_id}', 'mailstream={mailstream}'].join('&'),
	
	  'email_campaigns/blocks/translate': ['bootstrap.php?r=contentBlocks/campaign&session_id={session_id}', 'editor-mode=translate', 'id={campaign_id}'].join('&'),
	
	  'email_campaigns/edit': ['campaignmanager.php?session_id={session_id}', 'action=content', 'camp_id={campaign_id}'].join('&'),
	
	  'email_campaigns/edit/settings': ['campaignmanager.php?session_id={session_id}', 'action=details', 'camp_id={campaign_id}', 'mailstream={mailstream}'].join('&'),
	
	  'email_campaigns/edit/schedule': ['campaignmanager.php?session_id={session_id}', 'action=schedule', 'camp_id={campaign_id}'].join('&'),
	
	  'email_campaigns/copy': ['campaignmanager.php?session_id={session_id}', 'action=copy', 'copy={campaign_id}'].join('&'),
	
	  'email_campaigns/analysis/details': ['repmanager.php?session_id={session_id}', 'changed=0', 'action=analysis', 'camp_id={campaign_id}', 'page=1', 'search=', 'step=1', 'save_pref=on', 'tabdetails_length=10', 'tabfull_length=10', 'campaign_category=', 'admin=n', 'status=current', 'type=all'].join('&'),
	
	  'revenue_analytics/dashboard': ['bootstrap.php?session_id={session_id}', 'r=revenueAnalytics', 'from={start_date}', 'to={end_date}'].join('&'),
	
	  'email_analysis/list': ['repmanager.php?session_id={session_id}', 'action=overview'].join('&'),
	
	  'email_analysis/details': ['repmanager.php?session_id={session_id}', 'changed=0', 'action=analysis', 'camp_id={campaign_id}', 'launch_id={launch_id}', 'page=1', 'search=', 'step=1', 'save_pref=on', 'tabdetails_length=10', 'tabfull_length=10', 'campaign_category=', 'admin=n', 'status=current', 'type=all'].join('&'),
	
	  'bounce_management/list': ['adminmanager.php?session_id={session_id}', 'action=invmails', 'only_mailstreams={only_mailstreams}'].join('&'),
	
	  'contact/edit': ['userprofiles.php?session_id={session_id}', 'action=show', 'uid={uid}', 'sback={return_url}'].join('&'),
	
	  'contact_lists/details': ['userprofiles.php?session_id={session_id}', 'action=searchnlist', 'list_id={contact_list_id}'].join('&'),
	
	  'content_blocks/selector': ['bootstrap.php?session_id={session_id}', 'r=contentBlocks/selector'].join('&'),
	
	  'administrators/profile': ['bootstrap.php?session_id={session_id}', 'r=service', 'service=user-management', 'service_path=/admin/profile/{admin_id}'].join('&'),
	
	  'administrators/security-settings': ['bootstrap.php?session_id={session_id}', 'r=service', 'service=user-management', 'service_path=/security-settings'].join('&'),
	
	  'administrators/list': ['bootstrap.php?session_id={session_id}', 'r=service', 'service=user-management', 'service_path=/admin/list'].join('&'),
	
	  'combined_segments/list': ['bootstrap.php?session_id={session_id}', 'r=combinedSegment/list'].join('&'),
	
	  'combined_segments/create': ['bootstrap.php?session_id={session_id}', 'r=combinedSegment/edit'].join('&'),
	
	  'combined_segments/edit': ['bootstrap.php?session_id={session_id}', 'r=segmentationClient/index#/{segment_id}'].join('&'),
	
	  'segments/list': ['bootstrap.php?session_id={session_id}', 'r=segment/list'].join('&'),
	
	  'segments/combine': ['bootstrap.php?session_id={session_id}', 'r=combinedSegment/edit', 'filter_id={segment_id}'].join('&'),
	
	  'segments/combineThisSegment': ['bootstrap.php?session_id={session_id}', 'r=combinedSegment/edit', 'filter_id={segment_id}', 'useOldEditor={useOldEditor}'].join('&'),
	
	  'segments/edit': ['querymanager.php?session_id={session_id}', 'action=edit', 'query_id={segment_id}'].join('&'),
	
	  'program/list': ['bootstrap.php?session_id={session_id}', 'r=eventCenter/index#/'].join('&'),
	
	  'program/edit': ['bootstrap.php?session_id={session_id}', 'r=eventCenter/index#/edit/ac/{program_id}'].join('&'),
	
	  'program/create': ['bootstrap.php?session_id={session_id}', 'r=eventCenter/index#/edit/ac/'].join('&'),
	
	  'program/new': ['bootstrap.php?session_id={session_id}', 'r=eventCenter/index#/edit/ac/'].join('&'),
	
	  'trendsreporting/trends': ['bootstrap.php?session_id={session_id}', 'r=trendsreporting/trends'].join('&'),
	
	  'trendsreporting/trends/campaigns': ['bootstrap.php?session_id={session_id}', 'r=trendsreporting/trends', 'campaignIds={campaign_ids}', 'programId={program_id}', 'programName={program_name}', 'startDate={start_date}', 'endDate={end_date}'].join('&'),
	
	  'trendsreporting/trends/campaign': ['repmanager.php?action=analysis&page=1&step=11&session_id={session_id}', 'camp_id={campaign_id}'].join('&'),
	
	  'administrators/locked_out': 'custlogin.php?lockout=1',
	
	  'admin/data_onboarding': ['bootstrap.php?session_id={session_id}', 'r=service', 'service=data_onboarding', 'menu=12700'].join('&'),
	
	  'permission_settings/policies': ['bootstrap.php?session_id={session_id}', 'r=permissionSettings'].join('&'),
	
	  'permission_settings/roles': ['bootstrap.php?session_id={session_id}', 'r=permissionSettings#/roles'].join('&'),
	
	  'tactics': ['bootstrap.php?session_id={session_id}', 'r=tactics'].join('&'),
	
	  'tactics/list': ['bootstrap.php?session_id={session_id}', 'r=tactics', 'kpi={kpi_fake}'].join('&') + '#/?kpi={kpi}',
	
	  'tactics/details': ['bootstrap.php?session_id={session_id}', 'r=tactics#/?id={id}'].join('&'),
	
	  'me_push/edit': ['bootstrap.php?session_id={session_id}', 'r=service/index', 'service=push-notification', 'iframe=show', '#/campaigns/{id}'].join('&'),
	
	  'me_inapp/edit': ['bootstrap.php?session_id={session_id}', 'r=service/index', 'service=push-notification', 'iframe=show', '#/inapp-campaigns/{id}'].join('&'),
	
	  'me_push/report': ['bootstrap.php?session_id={session_id}', 'r=service/index', 'service=push-notification', 'iframe=show', '#/reports/push/{id}'].join('&'),
	
	  'me_push/campaigns': ['bootstrap.php?session_id={session_id}', 'r=service/index', 'service=push-notification', 'iframe=show', '#/campaigns'].join('&'),
	
	  'me_push/inapp-campaigns': ['bootstrap.php?session_id={session_id}', 'r=service/index', 'service=push-notification', 'iframe=show', '#/inapp-campaigns'].join('&'),
	
	  'me_push/inapp-campaigns/report': ['bootstrap.php?session_id={session_id}', 'r=service/index', 'service=push-notification', 'iframe=show', '#/reports/inapp/{id}'].join('&'),
	
	  'me_push/inapp-campaigns/edit': ['bootstrap.php?session_id={session_id}', 'r=service/index', 'service=push-notification', 'iframe=show', '#/inapp-campaigns/{id}'].join('&'),
	
	  'me_inbox/edit': ['bootstrap.php?session_id={session_id}', 'r=service/index', 'service=push-notification', 'iframe=show', '#/campaigns/{id}'].join('&'),
	
	  'me_inbox/report': ['bootstrap.php?session_id={session_id}', 'r=service/index', 'service=push-notification', 'iframe=show', '#/reports/inbox/{id}'].join('&'),
	
	  'mobile_wallet/edit': ['bootstrap.php?session_id={session_id}', 'r=mobileWallet/index', '#/campaigns/{id}'].join('&'),
	
	  'web_push/edit': ['bootstrap.php?session_id={session_id}', 'r=service/index', 'service=web-push', 'iframe=show', '#/campaigns/{id}'].join('&'),
	
	  'web_push/report': ['bootstrap.php?session_id={session_id}', 'r=service/index', 'service=web-push', 'iframe=show', '#/reports/web-push/{id}'].join('&'),
	
	  'sms/dashboard': ['bootstrap.php?session_id={session_id}', 'r=service', 'service=smsadapter'].join('&'),
	
	  'sms/settings': ['bootstrap.php?session_id={session_id}', 'r=smsSettings'].join('&'),
	
	  'rti/edit': ['bootstrap.php?session_id={session_id}', 'r=eventCenter/index#/edit/rti/{id}'].join('&'),
	
	  'automation/report': ['bootstrap.php?session_id={session_id}', 'r=eventCenter/index#/reporting/{program_type}/{id}?start_date={start_date}&end_date={end_date}'].join('&'),
	
	  'webhook_preset/edit': ['bootstrap.php?session_id={session_id}', 'r=webhookNode/index#/edit/{id}'].join('&'),
	
	  'revenue_attribution/settings': ['bootstrap.php?session_id={session_id}', 'r=revenueAttributor'].join('&'),
	
	  'homepage': ['bootstrap.php?session_id={session_id}', 'r=homepage'].join('&'),
	
	  'forms/edit': ['regmanager.php?session_id={session_id}', 'form_id={form_id}', 'action=description'].join('&'),
	
	  'smart_insight/settings': ['bootstrap.php?session_id={session_id}', 'r=smartinsight/CustomerRegistrySettings'].join('&')
	};
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var AbstractMessageHandler = __webpack_require__(84);
	var getFullUrlByTarget = __webpack_require__(81);
	
	var MessageHandlerNavigate = function (_AbstractMessageHandl) {
	  _inherits(MessageHandlerNavigate, _AbstractMessageHandl);
	
	  _createClass(MessageHandlerNavigate, [{
	    key: 'MESSAGE_EVENT',
	    get: function get() {
	      return 'navigate';
	    }
	  }]);
	
	  function MessageHandlerNavigate(global, transmitter) {
	    _classCallCheck(this, MessageHandlerNavigate);
	
	    var _this = _possibleConstructorReturn(this, (MessageHandlerNavigate.__proto__ || Object.getPrototypeOf(MessageHandlerNavigate)).call(this, global));
	
	    _this.transmitter = transmitter;
	    return _this;
	  }
	
	  _createClass(MessageHandlerNavigate, [{
	    key: 'handleMessage',
	    value: function handleMessage(message, event) {
	      var _this2 = this;
	
	      var flipperServicePromise = this.window.e.utils.getFlipperService();
	      return flipperServicePromise.then(function (flipperService) {
	        if (flipperService.isOn('ui_integration_remove_navigate')) {
	          return;
	        }
	
	        return _this2.navigate(message).then(function (success) {
	          return _this2.transmitter.respondToSender('navigate:response', { id: message.data.eventId, success: success }, event);
	        });
	      });
	    }
	  }, {
	    key: 'navigate',
	    value: function navigate(message) {
	      var url = getFullUrlByTarget({
	        sessionId: this.window.Emarsys.config.session_id,
	        target: message.data.target,
	        params: message.data.params
	      });
	
	      if (this.window.Emarsys.integration.unload.initialized) {
	        var promise = this.window.Emarsys.integration.dialog.confirmNavigation(url, this.getFakeConfirmMessage(message));
	
	        return promise.then(function () {
	          return true;
	        }).fail(function () {
	          return false;
	        });
	      } else {
	        this.window.location.href = url;
	        return this.window.$.Deferred().resolve(true).promise(); // eslint-disable-line new-cap
	      }
	    }
	  }]);
	
	  return MessageHandlerNavigate;
	}(AbstractMessageHandler);
	
	module.exports = MessageHandlerNavigate;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 84 */
/***/ function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var AbstractMessageHandler = function () {
	  function AbstractMessageHandler(global) {
	    _classCallCheck(this, AbstractMessageHandler);
	
	    this.window = global;
	  }
	
	  _createClass(AbstractMessageHandler, [{
	    key: 'cleanMessage',
	    value: function cleanMessage(text) {
	      return $('<div>' + text + '</div>').text();
	    }
	  }, {
	    key: 'getIntegrationIframe',
	    value: function getIntegrationIframe(integrationInstanceId) {
	      return this.window.document.getElementById('integration-' + integrationInstanceId);
	    }
	  }, {
	    key: 'getFakeConfirmMessage',
	    value: function getFakeConfirmMessage(message) {
	      var defaultConfirm = {
	        ok: this.window.gettext('Ok'),
	        cancel: this.window.gettext('Cancel'),
	        title: this.window.gettext('Confirm navigation'),
	        body: this.window.gettext('You have unsaved changes you will lose if you leave this page.'),
	        style: 'condensed'
	      };
	      var retval = {
	        source: {
	          integration_id: 'EMARSYS'
	        }
	      };
	
	      if (message.data.confirm) {
	        retval.data = this.window.$.extend({}, defaultConfirm, message.data.confirm);
	      } else {
	        retval.data = defaultConfirm;
	      }
	
	      return retval;
	    }
	  }, {
	    key: 'getMessageContainerElement',
	    value: function getMessageContainerElement() {
	      var container = $('#suite-integration-js-message-container');
	      if (container.length === 0) {
	        container = $('<div id="suite-integration-js-message-container"/>').appendTo('body');
	      }
	
	      return container;
	    }
	  }]);
	
	  return AbstractMessageHandler;
	}();
	
	module.exports = AbstractMessageHandler;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	var Logger = __webpack_require__(63);
	var AbstractMessageHandler = __webpack_require__(84);
	
	var MessageHandlerConfirm = function (_AbstractMessageHandl) {
	  _inherits(MessageHandlerConfirm, _AbstractMessageHandl);
	
	  function MessageHandlerConfirm() {
	    _classCallCheck(this, MessageHandlerConfirm);
	
	    return _possibleConstructorReturn(this, (MessageHandlerConfirm.__proto__ || Object.getPrototypeOf(MessageHandlerConfirm)).apply(this, arguments));
	  }
	
	  _createClass(MessageHandlerConfirm, [{
	    key: 'handleMessage',
	    value: function handleMessage(message) {
	      var _this2 = this;
	
	      var flipperServicePromise = this.window.e.utils.getFlipperService();
	      flipperServicePromise.then(function (flipperService) {
	        if (flipperService.isOn('ui_integration_remove_confirm')) {
	          return;
	        }
	
	        Logger.sendLog('confirm called');
	        _this2.window.Emarsys.integration.dialog.confirm(message);
	      });
	    }
	  }, {
	    key: 'MESSAGE_EVENT',
	    get: function get() {
	      return 'confirm';
	    }
	  }]);
	
	  return MessageHandlerConfirm;
	}(AbstractMessageHandler);
	
	module.exports = MessageHandlerConfirm;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	var Logger = __webpack_require__(63);
	
	var AbstractMessageHandler = __webpack_require__(84);
	
	var MessageHandlerEnableButton = function (_AbstractMessageHandl) {
	  _inherits(MessageHandlerEnableButton, _AbstractMessageHandl);
	
	  function MessageHandlerEnableButton() {
	    _classCallCheck(this, MessageHandlerEnableButton);
	
	    return _possibleConstructorReturn(this, (MessageHandlerEnableButton.__proto__ || Object.getPrototypeOf(MessageHandlerEnableButton)).apply(this, arguments));
	  }
	
	  _createClass(MessageHandlerEnableButton, [{
	    key: 'handleMessage',
	    value: function handleMessage(message) {
	      Logger.sendLog('enable_button called', { selector: message.data.selector });
	      this.window.$(message.data.selector).removeClass('e-btn-disabled');
	    }
	  }, {
	    key: 'MESSAGE_EVENT',
	    get: function get() {
	      return 'enable_button';
	    }
	  }]);
	
	  return MessageHandlerEnableButton;
	}(AbstractMessageHandler);
	
	module.exports = MessageHandlerEnableButton;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	var Logger = __webpack_require__(63);
	
	var AbstractMessageHandler = __webpack_require__(84);
	
	var MessageHandlerFit = function (_AbstractMessageHandl) {
	  _inherits(MessageHandlerFit, _AbstractMessageHandl);
	
	  function MessageHandlerFit() {
	    _classCallCheck(this, MessageHandlerFit);
	
	    return _possibleConstructorReturn(this, (MessageHandlerFit.__proto__ || Object.getPrototypeOf(MessageHandlerFit)).apply(this, arguments));
	  }
	
	  _createClass(MessageHandlerFit, [{
	    key: 'handleMessage',
	    value: function handleMessage(message) {
	      Logger.sendLog('fit called');
	      var $iframe = $(this.getIntegrationIframe(message.source.integration_instance_id));
	      var height = $iframe.height() + (document.body.offsetHeight - document.body.scrollHeight);
	
	      $iframe.height(height).parent().height(height);
	    }
	  }, {
	    key: 'MESSAGE_EVENT',
	    get: function get() {
	      return 'fit';
	    }
	  }]);
	
	  return MessageHandlerFit;
	}(AbstractMessageHandler);
	
	module.exports = MessageHandlerFit;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var AbstractMessageHandler = __webpack_require__(84);
	var getFullUrlByTarget = __webpack_require__(81);
	
	var GetUrl = function (_AbstractMessageHandl) {
	  _inherits(GetUrl, _AbstractMessageHandl);
	
	  _createClass(GetUrl, [{
	    key: 'MESSAGE_EVENT',
	    get: function get() {
	      return 'get_url';
	    }
	  }]);
	
	  function GetUrl(global, transmitter) {
	    _classCallCheck(this, GetUrl);
	
	    var _this = _possibleConstructorReturn(this, (GetUrl.__proto__ || Object.getPrototypeOf(GetUrl)).call(this, global));
	
	    _this.transmitter = transmitter;
	    return _this;
	  }
	
	  _createClass(GetUrl, [{
	    key: 'handleMessage',
	    value: function handleMessage(message, event) {
	      var _this2 = this;
	
	      var flipperServicePromise = this.window.e.utils.getFlipperService();
	      return flipperServicePromise.then(function (flipperService) {
	        if (flipperService.isOn('ui_integration_remove_get_full_url_by_target')) {
	          return;
	        }
	
	        try {
	          var url = getFullUrlByTarget({
	            sessionId: _this2.window.Emarsys.config.session_id,
	            target: message.data.target,
	            params: message.data.params
	          });
	
	          _this2.transmitter.respondToSender('get_url:response', { id: message.data.eventId, success: true, url: url }, event);
	        } catch (e) {
	          _this2.transmitter.respondToSender('get_url:response', { id: message.data.eventId, success: false, error: e.message }, event);
	        }
	      });
	    }
	  }]);
	
	  return GetUrl;
	}(AbstractMessageHandler);
	
	module.exports = GetUrl;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var Logger = __webpack_require__(63);
	var AbstractMessageHandler = __webpack_require__(84);
	
	var MessageHandlerUnloadInit = function (_AbstractMessageHandl) {
	  _inherits(MessageHandlerUnloadInit, _AbstractMessageHandl);
	
	  function MessageHandlerUnloadInit() {
	    _classCallCheck(this, MessageHandlerUnloadInit);
	
	    return _possibleConstructorReturn(this, (MessageHandlerUnloadInit.__proto__ || Object.getPrototypeOf(MessageHandlerUnloadInit)).apply(this, arguments));
	  }
	
	  _createClass(MessageHandlerUnloadInit, [{
	    key: 'handleMessage',
	    value: function handleMessage(message) {
	      var _this2 = this;
	
	      var flipperServicePromise = this.window.e.utils.getFlipperService();
	      return flipperServicePromise.then(function (flipperService) {
	        if (flipperService.isOn('ui_integration_remove_intercom_track_event')) {
	          return;
	        }
	
	        Logger.sendLog('intercom:track_event called');
	        var intercom = _this2.window.Intercom;
	
	        intercom('trackEvent', message.data.name, message.data.metadata);
	        intercom('update');
	      });
	    }
	  }, {
	    key: 'MESSAGE_EVENT',
	    get: function get() {
	      return 'intercom:track_event';
	    }
	  }]);
	
	  return MessageHandlerUnloadInit;
	}(AbstractMessageHandler);
	
	module.exports = MessageHandlerUnloadInit;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var Logger = __webpack_require__(63);
	var AbstractMessageHandler = __webpack_require__(84);
	
	var MessageHandlerModal = function (_AbstractMessageHandl) {
	  _inherits(MessageHandlerModal, _AbstractMessageHandl);
	
	  function MessageHandlerModal() {
	    _classCallCheck(this, MessageHandlerModal);
	
	    return _possibleConstructorReturn(this, (MessageHandlerModal.__proto__ || Object.getPrototypeOf(MessageHandlerModal)).apply(this, arguments));
	  }
	
	  _createClass(MessageHandlerModal, [{
	    key: 'handleMessage',
	    value: function handleMessage(message) {
	      if (message.data.src.match(/^\/{1}[^\/]+/)) {
	        message.data.src = '//' + this.window.location.host + message.data.src;
	        message.data.src = message.data.src.replace('{session_id}', this.window.Emarsys.config.session_id);
	      }
	      Logger.sendLog('modal called', { src: message.data.src });
	
	      this.window.Emarsys.integration.dialog.modal(message);
	    }
	  }, {
	    key: 'MESSAGE_EVENT',
	    get: function get() {
	      return 'modal';
	    }
	  }]);
	
	  return MessageHandlerModal;
	}(AbstractMessageHandler);
	
	module.exports = MessageHandlerModal;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var AbstractMessageHandler = __webpack_require__(84);
	var Logger = __webpack_require__(63);
	
	var MessageHandlerModalClose = function (_AbstractMessageHandl) {
	  _inherits(MessageHandlerModalClose, _AbstractMessageHandl);
	
	  function MessageHandlerModalClose() {
	    _classCallCheck(this, MessageHandlerModalClose);
	
	    return _possibleConstructorReturn(this, (MessageHandlerModalClose.__proto__ || Object.getPrototypeOf(MessageHandlerModalClose)).apply(this, arguments));
	  }
	
	  _createClass(MessageHandlerModalClose, [{
	    key: 'handleMessage',
	    value: function handleMessage() {
	      Logger.sendLog('modal close called');
	      this.window.Emarsys.integration.dialog.close();
	    }
	  }, {
	    key: 'MESSAGE_EVENT',
	    get: function get() {
	      return 'modal:close';
	    }
	  }]);
	
	  return MessageHandlerModalClose;
	}(AbstractMessageHandler);
	
	module.exports = MessageHandlerModalClose;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	
	var Logger = __webpack_require__(63);
	var AbstractMessageHandler = __webpack_require__(84);
	
	var MessageHandlerProxy = function (_AbstractMessageHandl) {
	  _inherits(MessageHandlerProxy, _AbstractMessageHandl);
	
	  function MessageHandlerProxy() {
	    _classCallCheck(this, MessageHandlerProxy);
	
	    return _possibleConstructorReturn(this, (MessageHandlerProxy.__proto__ || Object.getPrototypeOf(MessageHandlerProxy)).apply(this, arguments));
	  }
	
	  _createClass(MessageHandlerProxy, [{
	    key: 'handleMessage',
	    value: function handleMessage(message) {
	      message.data.envelope = message.data.envelope || {};
	      try {
	        Logger.sendLog('proxy called', Object.assign({ event: message.data.event }, message.data.envelope));
	      } catch (_) {
	        // drop the log
	      }
	
	      this.window.Emarsys.integration.messageToService(message.data.event, message.data.envelope, message.data.integrationInstanceId);
	    }
	  }, {
	    key: 'MESSAGE_EVENT',
	    get: function get() {
	      return 'proxy';
	    }
	  }]);
	
	  return MessageHandlerProxy;
	}(AbstractMessageHandler);
	
	module.exports = MessageHandlerProxy;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	var Logger = __webpack_require__(63);
	
	var AbstractMessageHandler = __webpack_require__(84);
	
	var MessageHandlerRefresh = function (_AbstractMessageHandl) {
	  _inherits(MessageHandlerRefresh, _AbstractMessageHandl);
	
	  function MessageHandlerRefresh() {
	    _classCallCheck(this, MessageHandlerRefresh);
	
	    return _possibleConstructorReturn(this, (MessageHandlerRefresh.__proto__ || Object.getPrototypeOf(MessageHandlerRefresh)).apply(this, arguments));
	  }
	
	  _createClass(MessageHandlerRefresh, [{
	    key: 'handleMessage',
	    value: function handleMessage() {
	      var _this2 = this;
	
	      var flipperServicePromise = this.window.e.utils.getFlipperService();
	      flipperServicePromise.then(function (flipperService) {
	        if (flipperService.isOn('ui_integration_remove_refresh')) {
	          return;
	        }
	
	        Logger.sendLog('refresh called');
	        _this2.window.location.reload();
	      });
	    }
	  }, {
	    key: 'MESSAGE_EVENT',
	    get: function get() {
	      return 'refresh';
	    }
	  }]);
	
	  return MessageHandlerRefresh;
	}(AbstractMessageHandler);
	
	module.exports = MessageHandlerRefresh;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	var Logger = __webpack_require__(63);
	
	var AbstractMessageHandler = __webpack_require__(84);
	
	var MessageHandlerResize = function (_AbstractMessageHandl) {
	  _inherits(MessageHandlerResize, _AbstractMessageHandl);
	
	  function MessageHandlerResize() {
	    _classCallCheck(this, MessageHandlerResize);
	
	    return _possibleConstructorReturn(this, (MessageHandlerResize.__proto__ || Object.getPrototypeOf(MessageHandlerResize)).apply(this, arguments));
	  }
	
	  _createClass(MessageHandlerResize, [{
	    key: 'handleMessage',
	    value: function handleMessage(message) {
	      Logger.sendLog('resize called', { instanceId: message.source.integration_instance_id });
	      var height = parseInt(message.data.height);
	      var $iframe = $(this.getIntegrationIframe(message.source.integration_instance_id));
	      var $toResize = $iframe.parent();
	
	      if (height) {
	        if ($iframe.parent().hasClass('e-dialog__content')) {
	          $toResize = $iframe.parent().parent();
	          height = height + 54;
	        }
	        $iframe.height(height);
	        $toResize.height(height);
	      }
	    }
	  }, {
	    key: 'MESSAGE_EVENT',
	    get: function get() {
	      return 'resize';
	    }
	  }]);
	
	  return MessageHandlerResize;
	}(AbstractMessageHandler);
	
	module.exports = MessageHandlerResize;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	/*** IMPORTS FROM imports-loader ***/
	
	'use strict';
	var Logger = __webpack_require__(63);
	var AbstractMessageHandler = __webpack_require__(84);
	
	var MessageHandlerTrack = function (_AbstractMessageHandl) {
	  _inherits(MessageHandlerTrack, _AbstractMessageHandl);
	
	  function MessageHandlerTrack() {
	    _classCallCheck(this, MessageHandlerTrack);
	
	    return _possibleConstructorReturn(this, (MessageHandlerTrack.__proto__ || Object.getPrototypeOf(MessageHandlerTrack)).apply(this, arguments));
	  }
	
	  _createClass(MessageHandlerTrack, [{
	    key: 'handleMessage',
	    value: function handleMessage(message) {
	      var _this2 = this;
	
	      var flipperServicePromise = this.window.e.utils.getFlipperService();
	      return flipperServicePromise.then(function (flipperService) {
	        if (flipperService.isOn('ui_integration_remove_track')) {
	          return;
	        }
	
	        Logger.sendLog('track called');
	        if (!_this2.window.analytics || !_this2.window.analytics.request) {
	          return false;
	        }
	
	        _this2.window.analytics.request('send', message.data);
	      });
	    }
	  }, {
	    key: 'MESSAGE_EVENT',
	    get: function get() {
	      return 'track';
	    }
	  }]);
	
	  return MessageHandlerTrack;
	}(AbstractMessageHandler);
	
	module.exports = MessageHandlerTrack;
	
	/*** EXPORTS FROM exports-loader ***/

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** integration.js
 **/